module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-mobile-822x134.73186dad.jpg";